import React from 'react';
import { useAuth } from '../context/AuthContext';
import { LogOut } from 'lucide-react';
import Logo from './Logo';
import NotificationBell from './NotificationBell';

const Navbar = () => {
  const { user, logout } = useAuth();

  return (
    <nav className="bg-white border-b border-gray-200 px-6 py-3">
      <div className="flex items-center justify-between">
        <Logo size="md" />

        <div className="flex items-center gap-4">
          <NotificationBell />

          <div className="flex items-center gap-3 pl-4 border-l border-gray-200">
            <div 
              className="w-10 h-10 rounded-full flex items-center justify-center text-white font-semibold"
              style={{ background: user?.avatar_color || '#2563eb' }}
            >
              {user?.prenom?.[0]}{user?.nom?.[0]}
            </div>
            <div className="text-sm">
              <div className="font-semibold text-gray-900">
                {user?.prenom} {user?.nom}
              </div>
              <div className="text-gray-500 text-xs">
                {user?.role === 'super_admin' ? 'Super Admin' : 
                 user?.role === 'senior' ? 'Gestionnaire Senior' : 'Gestionnaire'}
              </div>
            </div>
            <button
              onClick={logout}
              className="p-2 text-gray-600 hover:text-red-600 hover:bg-red-50 rounded-lg transition"
              title="Déconnexion"
            >
              <LogOut className="w-5 h-5" />
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
